const ChatScroll = {
    mounted() {
        console.log("ChatScroll: Hook mounted");
        this.scrollToBottom();

        setTimeout(() => {
            console.log("ChatScroll: Delayed scroll triggered");
            this.scrollToBottom();
        }, 1000);

        this.handleUpdates();
    },

    updated() {
        console.log("ChatScroll: Hook updated");
        this.scrollToBottom();
    },

    scrollToBottom() {
        const chatEnd = document.querySelector('#chat-end');
        if (chatEnd) {
            console.log("ChatScroll: Scrolling to bottom");
            chatEnd.scrollIntoView({ behavior: 'smooth' });
        } else {
            console.warn("ChatScroll: Chat end element not found");
        }
    },

    handleUpdates() {
        this.handleEvent("new_message", () => {
            console.log("ChatScroll: New message received");
            this.scrollToBottom();
        });

        this.handleEvent("messages_loaded", () => {
            console.log("ChatScroll: Messages loaded event received");
            this.scrollToBottom();
        });
    }
};

export default ChatScroll;